import { isEditableDocumentName } from './chilldoc.js';
import { isSheetDocumentName } from './sheet-document.js';
/**
 * Tệp Office soạn được bằng trình soạn Chill — APM-WDE-a / APM-PPE-a,
 * docs/plan-office-editors.md §2.
 *
 * - Word (`.docx`, `.doc`): mở thành tài liệu Chill, Lưu ghi lại **`.docx`**
 *   (`.doc` không thư viện nào ghi được — đổi đuôi như `.xls` → `.xlsx`).
 * - PowerPoint (`.pptx`): mở thành slide của Chill, Lưu ghi lại `.pptx`. `.ppt`
 *   **không** soạn được: không có bộ đọc mã nguồn mở (plan-my-files §2.6).
 *
 * Cùng với `sheet-document.ts`, đây là phần "ngoài `DocumentFormat`" của
 * `isEditableFileName`.
 */
export const WORD_EXTENSIONS = ['.docx', '.doc'];
export const PPTX_EXTENSION = '.pptx';
export const DOCX_EXTENSION = '.docx';
export const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const PPTX_MIME = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export function isWordDocumentName(filename) {
    const lower = filename.toLowerCase();
    return WORD_EXTENSIONS.some((extension) => lower.endsWith(extension));
}
export function isPptxDocumentName(filename) {
    return filename.toLowerCase().endsWith(PPTX_EXTENSION);
}
export function officeKindOf(filename) {
    if (isWordDocumentName(filename))
        return 'word';
    if (isPptxDocumentName(filename))
        return 'pptx';
    return null;
}
/** Tên tệp sau khi lưu từ trình soạn: `.doc` → `.docx`; còn lại giữ nguyên. */
export function officeSaveName(filename) {
    return filename.toLowerCase().endsWith('.doc')
        ? filename.slice(0, -'.doc'.length) + DOCX_EXTENSION
        : filename;
}
/** Tệp nào trang Tệp mở để sửa được: tài liệu chữ, bảng tính, hay Office (Word/PowerPoint). */
export function isEditableFileName(filename) {
    return (isEditableDocumentName(filename) ||
        isSheetDocumentName(filename) ||
        officeKindOf(filename) !== null);
}
/**
 * Bản mới có được thay bản cũ không (`revise`, "Lưu thành phiên bản khác"): cùng đuôi,
 * hoặc một trong các cặp đổi đuôi mà trình soạn buộc phải làm: `.xls` → `.xlsx`,
 * `.doc` → `.docx`. `.md` → `.chilldoc` vẫn bị từ chối (APM-CD-a).
 */
export function sameEditableFamily(previousName, nextName) {
    const previous = extensionOf(previousName);
    const next = extensionOf(nextName);
    if (previous === next)
        return true;
    return (previous === 'xls' && next === 'xlsx') || (previous === 'doc' && next === 'docx');
}
function extensionOf(filename) {
    const dot = filename.lastIndexOf('.');
    return dot < 0 ? '' : filename.slice(dot + 1).toLowerCase();
}
//# sourceMappingURL=office-document.js.map